import * as DocumentsActionCreators from 'stores/Documents/actions';
import * as TaxOrganizerActionCreators from 'stores/TaxOrganizer/actions';


export default {
  ...DocumentsActionCreators,
  ...TaxOrganizerActionCreators,
};
